import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  bulkApplyMessage: {
    description: 'bulkApplyMessage.ordersShipmentModeBatchDetailsFull',
    defaultMessage: 'This will apply to {boldCount} selected {numberOfShipments, plural,one {shipment} other {shipments}}',
    id: 'H8OXWv',
  },
  ordersShipmentModeBatchDetailsFull: {
    description: 'bulkUpdateEpics.ordersShipmentModeBatchDetailsFull',
    defaultMessage: '{numberOfShipments, plural, one {# shipment} other {# shipments}}',
    id: '5OlNel',
  },
  ordersShipmentModeBatchDetailsFullSuccess: {
    description: 'bulkUpdateEpics.ordersShipmentModeBatchDetailsFullSuccess',
    defaultMessage: 'Applied this action to {numberOfShipments, plural, one {# shipment} other {# shipments}}',
    id: 'AP3amD',
  },
  bulkApplyMessageOrders: {
    description: 'bulkApplyMessage.orders',
    defaultMessage: 'This will apply to {boldOrderNumber} selected {numberOfOrders, plural,one {order} other {orders}}',
    id: 'ShrrM0',
  },
  ordersAndShipments: {
    description: 'bulkUpdateEpics.ordersAndShipments',
    defaultMessage:
      '{numberOfOrders, plural, one {# order} other {# orders}}, {numberOfShipments, plural, one {# shipment} other {# shipments}}',
    id: 'uVjDKN',
  },
  ordersAndShipmentsSuccess: {
    description: 'bulkUpdateEpics.ordersAndShipmentsSuccess',
    defaultMessage:
      'Applied this action to {numberOfOrders, plural, one {# order} other {# orders}}, {numberOfShipments, plural, one {# shipment} other {# shipments}}',
    id: 'Sy2K+p',
  },
  bulkApplyMessageShipments: {
    description: 'bulkApplyMessage.shipments',
    defaultMessage: 'This will apply to {boldNumberOfShipments} selected {numberOfShipments, plural,one {shipment} other {shipments}}',
    id: 'dfRiDT',
  },
  shipments: {
    description: 'bulkUpdateEpics.shipments',
    defaultMessage: '{numberOfShipments, plural, one {# shipment} other {# shipments}}',
    id: 'K+A70C',
  },
  shipmentsSuccess: {
    description: 'bulkUpdateEpics.shipmentsSuccess',
    defaultMessage: 'Applied this action to {numberOfShipments, plural, one {# shipment} other {# shipments}}',
    id: 'woZ5g+',
  },
  bulkApplyMessageBatchDetailsFull: {
    description: 'bulkApplyMessage.batchDetailsFull',
    defaultMessage: 'This will apply to {boldCount} selected {numberOfShipments, plural,one {shipment} other {shipments}}',
    id: 'Vruynp',
  },
  batchDetailsFull: {
    description: 'bulkUpdateEpics.batchDetailsFull',
    defaultMessage: '{numberOfShipments, plural, one {# shipment} other {# shipments}}',
    id: 'yR+P4C',
  },
  batchDetailsFullSuccess: {
    description: 'bulkUpdateEpics.batchDetailsFullSuccess',
    defaultMessage: 'Applied this action to {numberOfShipments, plural, one {# shipment} other {# shipments}}',
    id: 'APnys3',
  },
});
